import {
    service, leave_service
} from '@/utils/request'
let appId = "";
let secret = "";
if (process.env.NODE_ENV === 'production') { // 生产环境配置
    console.log('--------检测到环境参数:ccs,production!!!将使用生产环境配置--------');
    appId = "wxf0ceefd3ce9a40c9"; // 生产环境appId
} else if (process.env.NODE_ENV === 'development') { // dev环境配置
    console.log('--------检测到环境参数:ccs,development!!!将使用汉王--dev环境配置--------');
    appId = "wx5552c99f8159726d"; //汉王教育公众号appId
}

// 微信基本信息
export function getWXbaseInfo () {
    return {
        imgFileServerUrl: imgFileServerUrl,
        appId: appId,
        secret: secret
    }
}
// 获取微信code
export function getWXcode (redirect_uri) {
    return {
        weiXinCodeUrl: "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
    }
}
/*===============================登录============================== */
// 获取短信验证码
export function getVerificationCode (data) {
    return service({
        url: '/basic/api/attend/auth/v1/getVerificationCode',
        method: 'post',
        params: data
    })
}
// 登录
export function getLogin (data) {
    return service({
        url: '/basic/api/attend/auth/to_login',
        method: 'post',
        params: data
    })
}
// 根据用户ID，为用户绑定微信的openId
export function getBindWx (data) {
    return service({
        url: '/basic/api/attend/auth/v1/bind/wx',
        method: 'post',
        params: data
    })
}
// 获取openId
export function getOpenId (data) {
    return service({
        url: '/basic/api/attend/auth/v1/getOpenId',
        method: 'post',
        params: data
    })
}
// 获取用户信息
export function getUserRole (data) {
    return service({
        url: '/basic/api/attend/auth/v1/getUserRole',
        method: 'post',
        params: data
    })
}
// 判断openId是否被绑定
export function getOpenIdEnable (data) {
    return service({
        url: '/basic/api/attend/auth/v1/openIdEnable',
        method: 'post',
        params: data
    })
}
// 微信openId登录
export function getLoginWx (data) {
    return service({
        url: '/basic/api/attend/auth/v1/sign/wx',
        method: 'post',
        params: data
    })
}
// 用户注销微信的openid
export function getUnbindWx (data) {
    return service({
        url: '/basic/api/attend/auth/v1/unbind/wx',
        method: 'post',
        params: data
    })
}
// 家长手机号验证码登录
export function getParentFirstLogin (data) {
    return service({
        url: '/basic/api/attend/auth/v1/parentFirstLogin',
        method: 'post',
        params: data,
    })
}
// 获取用户所在时段
export function getUserShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listUserShiftPeriod',
        method: 'post',
        params: data,
    })
}
/*===============================班级============================== */
// 获取班级当日时段学生考勤数据
export function getClassStatCard (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/classStatCard',
        method: 'post',
        params: data
    })
}
// 获取班级所在时段
export function getClassShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listClassShiftPeriod',
        method: 'post',
        params: data
    })
}
// 获取班级住宿生所在时段
export function getClassBoarderShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listClassBoarderShiftPeriod',
        method: 'post',
        params: data
    })
}
// 获取班级住宿生考勤
export function getClassBoarderStatCard (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/classBoarderStatCard',
        method: 'post',
        params: data
    })
}

/*===============================年级============================== */
// 获取年级当日时段学生考勤数据
export function getGradeStatCard (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listGradeStatCard',
        method: 'post',
        params: data
    })
}
// 获取年级所在时段
export function getGradeShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listGradeShiftPeriod',
        method: 'post',
        params: data
    })
}
// 获取年级住宿生所在时段
export function getGradeBoarderShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listGradeBoarderShiftPeriod',
        method: 'post',
        params: data
    })
}
// 获取年级住宿生考勤数据
export function getGradeBoarderStatCard (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listGradeBoarderStatCard',
        method: 'post',
        params: data
    })
}
/*===============================异常考勤============================== */
export function getExceptionList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listBranchException',
        method: 'post',
        params: data
    })
}
// 获取住宿生异常考勤
export function getBoarderExceptionList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listBoarderException',
        method: 'post',
        params: data
    })
}
/*===============================部门考勤============================== */
// 获取部门当日时段老师考勤数据
export function getBranchStatCard (data, params) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/branchStatCard',
        method: 'post',
        params: params,
        data
    })
}
// 获取部门所在时段
export function getBranchShiftPeriodList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listBranchShiftPeriod',
        method: 'post',
        params: data,
    })
}
/*===============================我的考勤============================== */
export function getEmployAttendanceList (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/listEmployAttendance',
        method: 'post',
        params: data,
    })
}
// 获取考勤详情
export function getAttendanceDetail (data) {
    return service({
        url: '/basic/api/attend/gradeClass/vi/getAttendanceDetail',
        method: 'post',
        params: data,
    })
}
// 班级当天通行记录
export function getClassSchoolLeaveMsgList (data) {
    return leave_service({
        url: '/basic/api/auth/v1/listClassSchoolLeaveMsg',
        method: 'post',
        params: data
    })
}
